import {OperatingAreaEntity} from "@ots-frontend/ots-data";
import {BaseEntitySelect, BaseEntitySelectProps} from "../base-entity-select";

export type BaseOperatingAreaSelectProps = BaseEntitySelectProps<OperatingAreaEntity>;

export const BaseOperatingAreaSelect = (props: BaseOperatingAreaSelectProps) => {
    return <BaseEntitySelect {...props} />;
};
